import { render, staticRenderFns } from "./OilImmersedPage.vue?vue&type=template&id=141659d3"
import script from "./OilImmersedPage.vue?vue&type=script&lang=js"
export * from "./OilImmersedPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports